import { JsonConverter, JsonCustomConvert } from 'json2typescript';

export class DataRow {
  [key: string]: any;
}

@JsonConverter
export class DataRowConverter implements JsonCustomConvert<DataRow> {
  deserialize(obj: any): DataRow {
    const dataRow = new DataRow();
    Object.keys(obj).forEach(key => {
      dataRow[key] = obj[key];
    });
    return dataRow;
  }

  serialize(dataRow: DataRow): any {
    const obj: any = {};
    Object.keys(dataRow).forEach(key => {
      obj[key] = dataRow[key];
    });
    return obj;
  }
}